var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","color":"success"},on:{"click":_vm.exportExcel}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-file-excel")]),_vm._v("\n  Xuất Excel\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }